import { IAccount, IAddress, IHeadquarters } from '@/models';

export const getAccountHeadquarters = (
  account?: IAccount | null,
): IHeadquarters[] => {
  return (
    account?.settings.headquarters?.filter(({ name }) => Boolean(name)) ?? []
  );
};

export const getDefaultHeadquartersAddress = (
  account?: IAccount | null,
): IAddress | null => {
  const headquartersAddress = account?.settings.headquarters?.[0]?.address;

  if (headquartersAddress && typeof headquartersAddress !== 'string') {
    return headquartersAddress;
  }

  return account?.settings.hqAddress ?? null;
};
